import { applyTranslations, getCurrentLanguage } from './core/i18n.js';

function run() {
  applyTranslations(document);
  document.documentElement.setAttribute('lang', getCurrentLanguage());
}

window.addEventListener('DOMContentLoaded', run);
window.addEventListener('languagechange', run);
